//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      reviews: [
        {
          id: 1,
          ratingFirst: 8.6,
          ratingSecond: 10,
          iconMarkup: `${require('~/assets/svg/our-rating-reclame-aqui.svg?raw')}`,
        },
        {
          id: 2,
          ratingFirst: 4.7,
          ratingSecond: 5,
          iconMarkup: `${require('~/assets/svg/our-rating-google.svg?raw')}`,
        },
        {
          id: 3,
          ratingFirst: 84,
          ratingSecond: 100,
          iconMarkup: `${require('~/assets/svg/our-rating-facebook.svg?raw')}`,
        },
      ],
    };
  },
};
